module.exports = __webpack_public_path__ + "static/media/logo-big.94bf1100.png";